
 <div *ngIf="isLoading | async" class="overlay">
    <ngx-spinner class="spinner" bdColor = "rgba(255, 255, 255, 0.8)"
    size = "default"
    color = "#76C04D" 
    type = "line-scale" 
    [fullScreen] = "true">
    <p style="color: rgba(255, 255, 255, 0.8)" >
         Loading... </p>
        </ngx-spinner>
  </div> 

 